const lineHeight = {
  heading: 1.042,
  body: 1.333,
};

export type SystemLineHeightMap = typeof lineHeight;
export type SystemLineHeight = keyof SystemLineHeightMap;
export default lineHeight;
